// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W7SnfpQBsnQpM2SjSKTC{align-items:center;gap:8px;height:24px;display:flex}.EnshvjQn1gq_GGpR8wTv,.arapTmJjeUsKkcyHwxz1{color:var(--content-brand-primary);margin-left:-4px}.DgFwNojVtokP58fwrAoC{pointer-events:none}.hg7L49gdss4ctld4TqBP{padding-left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `W7SnfpQBsnQpM2SjSKTC`,
	"wrapIcon": `EnshvjQn1gq_GGpR8wTv`,
	"icon": `arapTmJjeUsKkcyHwxz1`,
	"disabled": `DgFwNojVtokP58fwrAoC`,
	"player": `hg7L49gdss4ctld4TqBP`
};
export default ___CSS_LOADER_EXPORT___;
